import { TemplateType } from '../types';

/**
 * Token vietati per canale: impedisce di usare nel nome del template
 * termini che appartengono a un canale diverso da quello selezionato.
 *
 * Il check splitta il nome per '_' e verifica che nessun token (lowercase)
 * sia nella blocklist del canale selezionato.
 * Questo evita falsi positivi su parole composte (es. "pushback", "mailing").
 */
export const CHANNEL_FORBIDDEN_TOKENS: Record<TemplateType, string[]> = {
    EMAIL: ['push', 'sms'],
    SMS:   ['email', 'mail', 'push'],
    PUSH:  ['email', 'mail', 'sms'],
};

/**
 * Valida il nome template rispetto al canale selezionato.
 * Controlla se il nome contiene (come sottostringa) uno dei termini vietati.
 * @returns array di token vietati trovati (vuoto = valido)
 */
export const getChannelNameConflicts = (
    templateName: string,
    channelType: TemplateType
): string[] => {
    if (!templateName || !channelType) return [];
    const forbidden = CHANNEL_FORBIDDEN_TOKENS[channelType] || [];
    const nameLower = templateName.toLowerCase();
    return forbidden.filter(f => nameLower.includes(f));
};
